import CheckoutStepsConfig from '@/v-shop/checkout/common/checkout-steps-config'
CheckoutStepsConfig.expreso = function () {
	return {
		title: 'Expreso Envío a Domicilio Bioesencia',
		editable: true,
	}
}

